import { render, staticRenderFns } from "./documentAgentIcon.vue?vue&type=template&id=209b6a50&scoped=true"
import script from "./documentAgentIcon.vue?vue&type=script&lang=js"
export * from "./documentAgentIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209b6a50",
  null
  
)

export default component.exports